import { Link } from "react-router-dom";
import { Diamond, ExternalLink } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 bg-[#08090a] mt-20">
      {/* Sitewide responsible gambling strip */}
      <div className="bg-crimson/20 border-b border-crimson-bright/30">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-3 flex flex-wrap items-center gap-x-4 gap-y-1 justify-center text-center">
          <span className="overline text-crimson-bright">18+</span>
          <span className="text-sm text-white/70">
            Gambling involves risk. Please play responsibly and never bet more than you can afford to lose.
          </span>
          <a
            href="https://www.begambleaware.org"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gold hover:text-gold/80 transition-colors inline-flex items-center gap-1"
          >
            BeGambleAware.org <ExternalLink className="w-3 h-3" />
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2 mb-4">
            <Diamond className="w-5 h-5 text-gold" />
            <span className="font-display text-lg text-white">Licence to Play</span>
          </div>
          <p className="text-sm text-white/50 leading-relaxed max-w-xs">
            An independent, ad-supported field guide to baccarat. Education and entertainment only — no
            wagers are placed on this site.
          </p>
        </div>

        <div>
          <h4 className="overline text-gold/70 mb-4">Briefings</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/dossier" className="text-white/60 hover:text-white transition-colors">All Dossiers</Link></li>
            <li><Link to="/dossier/what-is-baccarat" className="text-white/60 hover:text-white transition-colors">What Is Baccarat</Link></li>
            <li><Link to="/dossier/baccarat-odds-and-house-edge" className="text-white/60 hover:text-white transition-colors">Odds & House Edge</Link></li>
            <li><Link to="/dossier/baccarat-strategy-guide" className="text-white/60 hover:text-white transition-colors">Strategy Guide</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="overline text-gold/70 mb-4">Field Kit</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/system" className="text-white/60 hover:text-white transition-colors">The System</Link></li>
            <li><Link to="/q-branch" className="text-white/60 hover:text-white transition-colors">Q Branch Calculator</Link></li>
            <li><Link to="/shoe-board" className="text-white/60 hover:text-white transition-colors">Shoe Pattern Board</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="overline text-gold/70 mb-4">Stay Safe</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/responsible-gambling" className="text-white/60 hover:text-white transition-colors">Responsible Gambling</Link></li>
            <li><a href="https://www.gamstop.co.uk" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-white transition-colors">GAMSTOP</a></li>
            <li><a href="https://www.begambleaware.org" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-white transition-colors">BeGambleAware</a></li>
            <li><a href="https://www.gamcare.org.uk" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-white transition-colors">GamCare</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="overline text-white/30">© {new Date().getFullYear()} Licence to Play — Classified Briefing</p>
          <p className="overline text-white/30">For entertainment & education only</p>
        </div>
      </div>
    </footer>
  );
};
